import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeComponentLinkFields {
  internalName?: EntryFieldTypes.Symbol
  url: EntryFieldTypes.Symbol
}

export type TypeComponentLinkSkeleton = EntrySkeletonType<TypeComponentLinkFields, 'componentLink'>
export type TypeComponentLink<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeComponentLinkSkeleton,
  Modifiers,
  Locales
>

export function isTypeComponentLink<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeComponentLink<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'componentLink'
}
